<interacta-user-menu-title
    [label]="'SHARED.USER_MENU.SELECT_THEME' | translate"
    (back)="back.emit()"
/>

<interacta-user-menu-separator />

<div class="flex items-start justify-center space-x-8 py-16" role="menu">
    <button
        cdkFocusInitial
        interacta-button-menu-vertical
        type="button"
        [attr.aria-pressed]="
            !currentTheme().isSystem && currentTheme().mode === 'light'
        "
        [icon]="'sun'"
        [label]="'SHARED.USER_MENU.THEME_LIGHT' | translate"
        [selected]="!currentTheme().isSystem && currentTheme().mode === 'light'"
        (click)="changeTheme.emit('light')"
    ></button>
    <button
        interacta-button-menu-vertical
        type="button"
        [attr.aria-pressed]="
            !currentTheme().isSystem && currentTheme().mode === 'dark'
        "
        [icon]="'moon'"
        [label]="'SHARED.USER_MENU.THEME_DARK' | translate"
        [selected]="!currentTheme().isSystem && currentTheme().mode === 'dark'"
        (click)="changeTheme.emit('dark')"
    ></button>
    <button
        interacta-button-menu-vertical
        type="button"
        [attr.aria-pressed]="currentTheme().isSystem"
        [icon]="'half-sun'"
        [label]="'SHARED.USER_MENU.THEME_DEFAULT' | translate"
        [selected]="currentTheme().isSystem"
        (click)="changeTheme.emit('system')"
    ></button>
</div>
